import { Typography, useTheme } from '@mui/material';

interface ErrorMessageProps {
  message?: string | null;
  absolute?: boolean;
}

function ErrorMessage({ message, absolute = true }: ErrorMessageProps) {
  const theme = useTheme();

  return (
    <Typography
      sx={{
        color: theme.palette.error.main,
        fontSize: '10px',
        mt: 1,
        ...(absolute === true && {
          position: 'absolute',
          bottom: '-20px',
        }),
      }}
    >
      {message}
    </Typography>
  );
}

export default ErrorMessage;
